module.exports = __webpack_public_path__ + "img/voting-up-disabled.65d64e22.svg";